export interface productSpecParamType {
    fieldType: string;
    generalKey: string;
    name: string;
    specParamId: string;
    unit: string;
}

export interface ProductSpecGroupType {
    generalKey: string;
    name: string;
    productCatagoryId: string;
    specGroupId: string;
    specParamList: productSpecParamType[];
}

export interface ProductCatagoryType {
    accessory: boolean;
    enable: boolean;
    generalKey: string;
    hasParent: boolean;
    name: string;
    pid: string;
    productCatagoryId: string;
    sort: number;
    specGroupList: ProductSpecGroupType[];
}

export interface ProductSkuType {
    ownSpec: string;
}

export interface ProductDetailType {
    skuList: ProductSkuType[];
}

export interface ProductCompareItemType {
    title: string;
    desc: string;
    generalKey: string;
}

const NULL_SYMBOL = '-';

const generateSpecValue = (product: any, group: any, param: any) => {
    const ownSpec = product && product?.skuList && product.skuList?.length && product?.skuList[0]?.ownSpec;
    const ownSpecObj = JSON.parse(typeof ownSpec === 'string' ? ownSpec : JSON.stringify(ownSpec) || '{}');
    const ownSpecGroup = ownSpecObj[group?.specGroupId];
    const ownSpecGroupObj = JSON.parse(typeof ownSpecGroup === 'string' ? ownSpecGroup : JSON.stringify(ownSpecGroup) || '{}');
    let specV = ownSpecGroupObj[param?.specParamId];
    if (param?.fieldType === 'boolean') {
        const v = !specV ? NULL_SYMBOL : ['false'].includes(specV) ? NULL_SYMBOL : '✓';
        return v;
    }
    if (!Number.isNaN(Number(specV))) {
        specV = specV + (param?.unit || '');
    }
    return specV || NULL_SYMBOL;
};

export const formatCompareSpec = (catagory: ProductCatagoryType, products: ProductDetailType[], keys?: string[]) => {
    if (!catagory || !products || !products.length || typeof window === 'undefined') {
        return null;
    }
    const locale = window.location.pathname.split('/')[1];
    const result: ProductCompareItemType[][] = [];
    products.map((product: ProductDetailType) => {
        const catagoryGroups =
            catagory && Array.isArray(catagory) && catagory[0]?.specGroupList && Array.isArray(catagory[0]?.specGroupList) ? catagory[0]?.specGroupList : null;
        const productResult: ProductCompareItemType[] = [];
        if (catagoryGroups) {
            catagoryGroups.map((catagoryGroup: ProductSpecGroupType) => {
                const groupParams =
                    catagoryGroup && catagoryGroup?.specParamList && Array.isArray(catagoryGroup?.specParamList) ? catagoryGroup?.specParamList : null;
                if (groupParams) {
                    groupParams.map((groupParam: productSpecParamType) => {
                        const specV = generateSpecValue(product, catagoryGroup, groupParam);
                        if (keys) {
                            if (keys.includes(groupParam.generalKey)) {
                                productResult.push({
                                    title: locale === 'sa' && String(specV).endsWith(' [* *]') ? String(specV).split(' [* *]')[0] : specV,
                                    desc: groupParam?.name,
                                    generalKey: groupParam?.generalKey,
                                });
                            }
                        } else {
                            productResult.push({
                                title: locale === 'sa' && String(specV).endsWith(' [* *]') ? String(specV).split(' [* *]')[0] : specV,
                                desc: groupParam?.name,
                                generalKey: groupParam?.generalKey,
                            });
                        }
                    });
                }
            });
        }

        // 按 keys 顺序排序
        if (keys && keys.length) {
            productResult.sort((a, b) => {
                const aIndex = keys.indexOf(a.generalKey);
                const bIndex = keys.indexOf(b.generalKey);
                return aIndex - bIndex;
            });
        }

        result.push(productResult);
    });

    // 去掉全部值为空的数据
    const newArr: ProductCompareItemType[][] = [];
    const allProductsParamEmptyIdx: number[] = [];
    result.map((items: ProductCompareItemType[], k: number) => {
        const productItem = [] as ProductCompareItemType[];
        if (k === 0) {
            items?.map((_: ProductCompareItemType, m: number) => {
                if (result.every((items: ProductCompareItemType[]) => items[m].title === NULL_SYMBOL)) {
                    allProductsParamEmptyIdx.push(m);
                }
            });
        }
        items?.map((item: ProductCompareItemType, n: number) => {
            if (!allProductsParamEmptyIdx.includes(n)) {
                productItem.push(item);
            }
        });
        newArr.push(productItem);
    });

    return newArr;
};
